import React, { useState, useEffect } from "react";
import { DownloadOutlined, StopOutlined, PrinterOutlined, DeleteOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { Button, Col, Table, Row, Space, Popconfirm, Form, Input, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import CustomTableSearch from "../common/CustomTableSearch";
import memberService from "../../api/member.service";
import ProgrammeService from "../../api/programme.service";
import { SUCCESS_STATUS } from "../../utility/Constants";
import * as XLSX from "xlsx";
import moment from 'moment';


const JcpHpPfMember = ({ programName, groupId, memberStatus }) => {
  let navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [selectedProgram, setSelectedProgram] = useState(0);
  const [jcpEnrollmentReceiptList, setJcpEnrollmentReceiptList] = useState([]);
  const [filteredSearchList, setFilteredSearchList] = useState([]);
  const [popconfirmVisibility, setPopconfirmVisibility] = useState({});
  const [noteValues, setNoteValues] = useState({});
  const [form] = Form.useForm();

  const hasInactive = jcpEnrollmentReceiptList.some(record => record.is_active === 'N');
  const pageSize = 10; // Number of items per page

  // Example of pagination from Ant Design Table or similar
  const pagination = {
    current: page, // Current page number
    pageSize: pageSize, // Number of items per page
  };

  const columns = [
    {
      title: '#',
      dataIndex: 'index',
      render: (text, record, index) => (pagination.current - 1) * pagination.pageSize + index + 1,
      width: '5%',
    },
    {
      title: 'Name',
      dataIndex: 'member_fname',
      key: 'member_fname',
      sorter: (a, b) => {
        const nameA = `${a.member_fname} ${a.member_lname}`;
        const nameB = `${b.member_fname} ${b.member_lname}`;
        return nameA.localeCompare(nameB);
      },
      render: (selectedObj, record) => (
        <Space>
          <span>{record.member_fname} {record.member_lname}</span>
        </Space>
      ),
    },
    {
      title: 'Primary Mobile',
      dataIndex: 'primary_mobile',
      key: 'primary_mobile',
    },
    {
      title: 'DOB',
      dataIndex: 'date_of_birth',
      key: 'date_of_birth',
    },
    {
      title: 'Father Name',
      dataIndex: 'father_name',
      key: 'father_name',
    },
    {
      title: 'Group/Shift',
      dataIndex: 'programme_group',
      key: 'programme_group',
    },
    // {
    //   title: hasInactive ? 'Inactive Date' : 'Validity',
    //   dataIndex: 'enrollment_start_date',
    //   key: 'enrollment_start_date',
    //   sorter: (a, b) => {
    //     const nameA = `${a.enrollment_start_date} ${a.enrollment_end_date}`;
    //     const nameB = `${b.enrollment_start_date} ${b.enrollment_end_date}`;
    //     return nameA.localeCompare(nameB);
    //   },
    //   render: (text, record) => {
    //     console.log('is_active:', record.is_active);
    //     console.log('inactive_date:', record.inactive_date);

    //     if (record.is_active === 'N' && record.inactive_date) {
    //       return (
    //         <Space>
    //           <span>{record.inactive_date}</span>
    //         </Space>
    //       );
    //     } else {
    //       return (
    //         <Space>
    //           <span>{record.enrollment_start_date} to {record.enrollment_end_date}</span>
    //         </Space>
    //       );
    //     }
    //   },
    // },

    {
      title: memberStatus === 'Y' ? 'Validity' : 'InActive Date',
      dataIndex: 'enrollment_start_date',
      key: 'enrollment_start_date',
      sorter: (a, b) => `${a.enrollment_start_date} ${a.enrollment_end_date}`.localeCompare(`${b.enrollment_start_date} ${b.enrollment_end_date}`),
      render: (text, record) => (
      
        <Space>
          <span>
            {memberStatus === 'Y' 
              ? (record.enrollment_start_date && record.enrollment_end_date 
                  ? `${(record.enrollment_start_date).replaceAll("/", "-")} to ${(record.enrollment_end_date).replaceAll("/", "-")}`
                  : '') 
              : (record.inactive_date 
                  ? (moment(record.inactive_date)).format("DD-MM-YYYY") 
                  : '')} 
          </span>
        </Space>
      ),
    },
    
    {
      title: 'Status',
      dataIndex: 'is_active',
      key: 'is_active',
      render: (text, record) => {
        const isActive = text === 'Y';
        return (
          <span
            style={{
              color: isActive ? 'green' : 'red',
              fontWeight: 'bold',
              padding: '4px 8px',
              borderRadius: '4px',
              backgroundColor: isActive ? 'rgba(0, 128, 0, 0.1)' : 'rgba(255, 0, 0, 0.1)',
            }}
          >
            {isActive ? 'Active' : 'Inactive'}
          </span>
        );
      },
    },

    // {
    //   title: 'Action',
    //   key: 'action',
    //   render: (text, record) => (
    //     <Space style={{ display: 'flex', flexDirection: 'row' }}>
    //       {record.is_active === 'Y' && record.STATE === 'DORMANT' && (
    //         <Popconfirm
    //           title={
    //             <div style={{ width: '300px' }}>
    //               <p>Are you sure you want to mark as inactive?</p>
    //               <Form form={form} layout="vertical" onFinish={() => handleStatusChange(record.enrollment_id)}>
    //                 <Form.Item
    //                   name={`inactive_note_${record.enrollment_id}`}
    //                   label="Note:"
    //                   rules={[
    //                     { required: true, message: 'Notes is required' },
    //                     { min: 1, message: 'Notes must be at least 1 character.' },
    //                   ]}
    //                   style={{ marginBottom: '0px' }}
    //                 >
    //                   <Input.TextArea rows={2} onChange={(e) => handleNoteChange(record.enrollment_id, e.target.value)} />
    //                 </Form.Item>
    //               </Form>
    //             </div>
    //           }
    //           icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
    //           visible={popconfirmVisibility[record.enrollment_id] || false}
    //           onConfirm={() => form.submit()}
    //           okText="Yes"
    //           cancelText="No"
    //           onCancel={() => togglePopconfirmVisible(record.enrollment_id)}
    //         >
    //           <Button type="danger" size="small" shape="round" onClick={() => togglePopconfirmVisible(record.enrollment_id)}>
    //             Inactive
    //           </Button>
    //         </Popconfirm>
    //       )}
    //     </Space>
    //   ),
    // },
  ];

  useEffect(() => {
    const data = {
      formdata: { short_code: programName },
    };
    ProgrammeService.programmeByCode(data).then((res) => {
      if (res.data.response_status === SUCCESS_STATUS) {
        setSelectedProgram(res.data.response_data[0].programme_id);
      }
    });
  }, [programName]);

  useEffect(() => {
    setPopconfirmVisibility({});
    const data = {
      formdata: { programme_id: selectedProgram, programme_group_id: groupId, member_status: memberStatus }
    };
    console.log("formDataMenber", data)
    memberService.memberListByProgramGroup(data).then((res) => {
      console.log(res.data.response_data);
      setJcpEnrollmentReceiptList(res.data.response_data);
      setFilteredSearchList(res.data.response_data);
    });
  }, [selectedProgram, groupId, memberStatus]);

  const onSearch = (e) => {
    setFilteredSearchList([]);
    const string = e.target.value;
    const x = jcpEnrollmentReceiptList.filter((data) => JSON.stringify(data).toLowerCase().indexOf(string.toLowerCase()) !== -1);
    setFilteredSearchList(x);
  };

  const exportToExcel = () => {
    const exportData = filteredSearchList.map(item => ({
      'Name': `${item.member_fname} ${item.member_lname}`,
      'Primary Mobile': item.primary_mobile,
      'DOB': item.date_of_birth,
      'Father Name': item.father_name,
      'Group/Shift': item.programme_group,
      'Validity': `${item.enrollment_start_date} to ${item.enrollment_end_date}`,
    }));
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, "member_list.xlsx");
  };

  const handleNoteChange = (id, value) => {
    setNoteValues(prev => ({ ...prev, [id]: value }));
  };

    const togglePopconfirmVisible = (id) => {
    setPopconfirmVisibility(prev => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const handleStatusChange = (enrollmentId) => {
    const note = noteValues[enrollmentId] || '';

    memberService.inActiveDormantMembers({
      formdata: { enrollment_id: enrollmentId, notes: note }
    }).then(res => {
      if (res.data.response_status === SUCCESS_STATUS) {
        const updatedList = jcpEnrollmentReceiptList.filter(item => item.enrollment_id !== enrollmentId);
        setJcpEnrollmentReceiptList(updatedList);
        setFilteredSearchList(updatedList);
        message.success(res.data.response_msg || "Status updated successfully");
      } else {
        message.error(res.data.response_msg || "Failed to update status");
      }
    }).catch(error => {
      message.error("An error occurred while updating status");
      console.error(error);
    });
  };



  return (
    <>
      <Row gutter={10}>
        <Col xs={24} xl={2}>
          <Button htmlType="button" shape="round" className="custom-button-green" onClick={exportToExcel}>
            <DownloadOutlined /> Excel
          </Button>
        </Col>
        <Col xs={24} xl={22}>
          <CustomTableSearch onSearchTable={onSearch} style={{ marginBottom: "8px" }} />
        </Col>
      </Row>
      <Table
        dataSource={filteredSearchList}
        columns={columns}
        rowKey="enrollment_id"
        pagination={{
          current: page,
          pageSize,
          total: filteredSearchList.length,
          onChange: (page) => setPage(page),
        }}
      />
    </>
  );
};

export default JcpHpPfMember;
